<template>
    <div class="container">
        <img id="image" v-bind:src="image_src" v-if="image_src" alt="Imagen subida."/>
    </div>
</template>
<style scoped>
.container > img{
    width:100%;
    height: 100%;
    object-fit: cover;
}
</style>
<script>
    export default {
        props: ['type', 'page', 'number'],
        computed: {
            dbId(){
                return `${this.type}-${this.page}-${this.number}`
            },
            eventId(){
                return `${this.dbId}_image_updated`;
            }
        },
        data: function() {
            return {
                image_src: "",
            }
        },
        methods: {
            async updateImage(){
                var image = await this.$db.images.get({
                    id: this.dbId,
                }).catch(function(error){
                    console.log("error uploading file" + error);
                });
                if (image === undefined) return;
                this.image_src = URL.createObjectURL(image.blob);
            }
        },
        async created() {
            await this.updateImage();
            var nestedThis = this;
            this.$eventHub.$on(this.eventId, function(){
                nestedThis.updateImage();
            });            
        },
        beforeDestroy() {
            this.$eventHub.$off(this.eventId);
        }
    }
</script>